import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { numberFormatter } from "@/utils";

export const DashboardCount = ({ count, title, bg, color }) => {
  const { isDark } = useSelector((state) => state.theme);

  return (
    <div
      className={`w-100 p-4 h-100 rounded-2 ${!isDark && "text-black"}`}
      style={{ background: bg, color: color || "#ffffff" }}
    >
      <div
        style={{
          fontSize: "32px",
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        {numberFormatter(count, 0)}
      </div>
      <div
        style={{
          fontSize: "14px",
          fontWeight: "500",
          textAlign: "center",
        }}
      >
        {title}
      </div>
    </div>
  );
};

export default DashboardCount;

DashboardCount.propTypes = {
  count: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  bg: PropTypes.string,
  color: PropTypes.string,
};
